import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaginationTotal = (from, to, size) => (_jsxs("span", Object.assign({ className: 'react-bootstrap-table-pagination-total' }, { children: ["Showing ", from, " to ", to, " of ", size, " Results"] })));
